var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveAdminReportsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 4C7.5 3.82877 7.51722 3.66155 7.55001 3.5H6C4.61929 3.5 3.5 4.61929 3.5 6V20C3.5 21.3807 4.61929 22.5 6 22.5H18C19.3807 22.5 20.5 21.3807 20.5 20V6C20.5 4.61929 19.3807 3.5 18 3.5H16.45C16.4828 3.66155 16.5 3.82877 16.5 4C16.5 5.38071 15.3807 6.5 14 6.5H10C8.61929 6.5 7.5 5.38071 7.5 4ZM8.5 4C8.5 3.82468 8.53008 3.65639 8.58535 3.5H15.4146C15.4699 3.65639 15.5 3.82468 15.5 4C15.5 4.82843 14.8284 5.5 14 5.5H10C9.17157 5.5 8.5 4.82843 8.5 4ZM7.5 14C7.22386 14 7 14.2239 7 14.5V17.5C7 17.7761 7.22386 18 7.5 18H8.5C8.77614 18 9 17.7761 9 17.5V14.5C9 14.2239 8.77614 14 8.5 14H7.5ZM11 12.5C11 12.2239 11.2239 12 11.5 12H12.5C12.7761 12 13 12.2239 13 12.5V17.5C13 17.7761 12.7761 18 12.5 18H11.5C11.2239 18 11 17.7761 11 17.5V12.5ZM15.5 10C15.2239 10 15 10.2239 15 10.5V17.5C15 17.7761 15.2239 18 15.5 18H16.5C16.7761 18 17 17.7761 17 17.5V10.5C17 10.2239 16.7761 10 16.5 10H15.5Z",
    fill: "#533A0A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.43234 3.80824C8.43234 2.82306 9.23099 2.02441 10.2162 2.02441H13.7838C14.769 2.02441 15.5677 2.82306 15.5677 3.80824C15.5677 4.79342 14.769 5.59207 13.7838 5.59207H10.2162C9.23099 5.59207 8.43234 4.79342 8.43234 3.80824Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveAdminReportsIcon);
export default __webpack_public_path__ + "static/media/active-admin-reports-icon.4c21fcf1907859a18272fcc8d4b7df40.svg";
export { ForwardRef as ReactComponent };